import { Emergency } from './Emergency.model';
import { Personal } from './Personal.model';
export class SelfFill  {
    name: string;
    email: string;
    emergency = new Emergency();
    hash: string;
    personal = new Personal();

    loadToEdit(r: any) {
        this.name = r.name ? r.name : '';
        this.email = r.email ? r.email : '';
        this.personal.loadToEdit(r.personal);
        this.emergency.loadToEdit({
            type: r.emergency.type ? r.emergency.type : 0,
            name: r.emergency.name ? r.emergency.name : '',
            phone: r.emergency.phone ? r.emergency.phone : ''
        })
        this.hash = r.hash;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/SelfFill.model.ts